import classNames from "classnames";
import React, { FC } from "react";

import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { Image } from "../elements";

const SOKLogo = "/sok/images/SOKLogo.svg";

interface ILogoProps {
	"data-testid"?: string;
	className?: string;
}

const Logo: FC<ILogoProps> = (props) => {
	const { state: location } = useConfigContext((state) => state.location);

	return (
		<div
			data-testid={props["data-testid"] ?? "SOKLogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={SOKLogo} alt="Company Logo" className="Logo" />
		</div>
	);
};

export default React.memo(Logo);
